import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Actor_Remove_Mutation = graphql(`
  mutation MissionForm_Actor_Remove(
    $actorId: Id!
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    removeMissionActor(
      actorId: $actorId
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useRemoveMissionActorMutation = () =>
  useGraphQLMutation(MissionForm_Actor_Remove_Mutation);
